// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-fineprint-js": () => import("./../../../src/templates/fineprint.js" /* webpackChunkName: "component---src-templates-fineprint-js" */),
  "component---src-templates-issue-js": () => import("./../../../src/templates/issue.js" /* webpackChunkName: "component---src-templates-issue-js" */),
  "component---src-templates-issue-pdf-js": () => import("./../../../src/templates/issue-pdf.js" /* webpackChunkName: "component---src-templates-issue-pdf-js" */)
}

